import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import moment from 'moment';
import last from 'lodash/last';
import find from 'lodash/find';
import get from 'lodash/get';

import Link from '../../../shared/link';

const propTypes = {
	row: PropTypes.object,
	statuses: PropTypes.array,
	intl: PropTypes.func,
	can: PropTypes.func,
	className: PropTypes.string,
	requestQueryString: PropTypes.string
};

const Row = ({
	row,
	statuses,
	intl,
	can,
	className,
	requestQueryString
}) => {
	return (
		<tr className={`${className} ${getRowStyle(statuses, row)}`}>
			<td className="datetime">
				<Link to={`external-tickets/${row.id}`} requestQueryString={requestQueryString} className="thread-link">
					<span className="date">{moment(row.updated_at).format('DD.MM.YYYY')}</span>
					<span className="at">{intl('at')}</span>
					<span className="time">{moment(row.updated_at).format('HH:mm')}</span>
				</Link>
			</td>
			<td>
				<Link to={`external-tickets/${row.id}`} requestQueryString={requestQueryString} className="thread-link">
					<span>
						{row.name}
					</span>
				</Link>
			</td>
			<td className="affiliate">
				<Link to={`external-tickets/${row.id}`} requestQueryString={requestQueryString} className="thread-link">
					<span className="email" title={row.email}>
						{row.email}
					</span>
				</Link>
			</td>
			<td
				className={cn({
					title: true,
					title__closed: !!row.closed_at,
					unread: !row.viewed_at
				})}
				width={1}
			>
				<Link to={`external-tickets/${row.id}`} requestQueryString={requestQueryString} className={cn({
					action_edit: true,
					unread: !row.viewed_at
				})}>
					<span className="text">{row.posts[0].text}</span>
				</Link>
			</td>
		</tr>
	);
};

const getRowStyle = (statusesList, row) => {
	let style = [];
	let rowStatus = row.status;
	style.push(get(find(statusesList, status => status.id === rowStatus), 'id'));

	let isWithoutAnswer = !last(row.posts).admin_id;

	let isLongWithoutAnswer = isWithoutAnswer &&
		Math.abs(moment.duration(moment(row.updated_at).diff()).asHours()) > 1;

	if (isLongWithoutAnswer) {
		style.push('long-without-answer');
	} else if (isWithoutAnswer) {
		style.push('without-answer');
	}

	return style.join(' ');
};

Row.propTypes = propTypes;

export default Row;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/external-threads/components/table/row.js